import React, { useEffect, useState, useRef } from "react";
import { useNavigate,useLocation  } from "react-router-dom";
import "./Newloginstyle.css";
import Swal from "sweetalert2";
import { baseurl } from "../../utility/helper";

const Candidatelogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [resendDisabled, setResendDisabled] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputsRefs = useRef([]);
  const [contact, setContact] = useState(""); // Mobile or email
  const [showVerificationForm, setShowVerificationForm] = useState(false);
  const [popupHidden, setPopupHidden] = useState(true);
  const [userId, setUserId] = useState(null);
  const [priviledge, setpriviledge] = useState("");
  const [TestCanID, setTestcandiID] = useState("");
  const [CanFirstName, setFirstname] = useState("");
  const [CanLastName, setLastName] = useState("");
  const [CanEmail, setEmail] = useState("");
  const [CanMobileNo, setMobileNo] = useState("");
  const [CanGender, setGender] = useState("");
  const [CanDob, setDob] = useState("");
  const [CanAadhar, setAadhar] = useState("");
  const fromPage = location.state?.fromPage || "unknown";
  const testId = location.state?.testId || "";
  const tab = location.state?.tab || "";

  const handleChange = (index, value) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    if (value && index < otp.length - 1) {
      inputsRefs.current[index + 1].focus();
    }
    setOtp(newOtp);
  };

  const handlePaste = (e) => {
    e.preventDefault();

    const pasteData = e.clipboardData.getData("text").trim();

    if (!/^\d+$/.test(pasteData)) return; // allow only numbers

    const pasteArray = pasteData.split("").slice(0, otp.length);

    const newOtp = [...otp];

    pasteArray.forEach((value, index) => {
      newOtp[index] = value;
    });

    setOtp(newOtp);

    // Focus last filled input
    const lastIndex = pasteArray.length - 1;
    if (lastIndex >= 0) {
      inputsRefs.current[lastIndex].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && index > 0 && !otp[index]) {
      const newOtp = [...otp];
      newOtp[index - 1] = ""; // Clear the current and previous input
      inputsRefs.current[index - 1].focus(); // Focus on the previous input
      setOtp(newOtp); // Update the OTP state
    }
  };

  useEffect(() => {
    const container = document.getElementById("container");
    const registerBtn = document.getElementById("register");
    const loginBtn = document.getElementById("login");

    const handleRegisterClick = () => {
      container.classList.add("active");
    };

    const handleLoginClick = () => {
      container.classList.remove("active");
    };

    registerBtn.addEventListener("click", handleRegisterClick);
    loginBtn.addEventListener("click", handleLoginClick);
    return () => {
      registerBtn.removeEventListener("click", handleRegisterClick);
      loginBtn.removeEventListener("click", handleLoginClick);
    };
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch(`${baseurl}/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ candidate: contact }), // Send mobile or email
      });

      const data = await response.json();
      if (data.success) {
        console.log('data',data);
        setTestcandiID(data.test_candidate_id);
        setFirstname(data.first_name);
        setLastName(data.last_name);
        setEmail(data.email);
        setMobileNo(data.mobile_no);
        setGender(data.gender);
        setAadhar(data.aadhar_last);
        setDob(data.dob);
        setUserId(data.userId);
        setpriviledge(data.priviledge);
        setShowVerificationForm(true);
        setPopupHidden(true);
      } else {
        alert(data.message);
        if (data.message === "You are already a member") {
          setTimeout(() => {
            navigate("/memberlogin");   // redirect here
          }, 500);
        } else {
          // fallback redirect
          setTimeout(() => {
            navigate("/Register");
          }, 500);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleSubmitClick2 = async (e) => {
     e.preventDefault(); // prevent page reload

    const otpValue = otp.join(""); // Combine OTP input values

    try {
      const response = await fetch(`${baseurl}/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, otp: otpValue }), // Send mobile or email and OTP
      });

      const data = await response.json();
      if (data.success) {
        console.log("Candidate Data:", priviledge);
        sessionStorage.setItem("CandidateID", TestCanID);
        sessionStorage.setItem("CandidateFname", CanFirstName);
        sessionStorage.setItem("CandidateLname", CanLastName);
        sessionStorage.setItem("CandidateEmail", CanEmail);
        sessionStorage.setItem("CandidateMobile", CanMobileNo);
        sessionStorage.setItem("Candidategender", CanGender);
        sessionStorage.setItem("Candidatedob", CanDob);
        sessionStorage.setItem("Candidateaadhar", CanAadhar);
        sessionStorage.setItem("Candidatepriviledge", priviledge);
        
        // if profile 100% complete then direct open 
        setTimeout(() => {
          navigate("/Profile", { state: { type: "candidate", defaultTab: "#four" } });
          window.location.reload(); 
        }, 800);
        // if (fromPage == "PreTest") {
        //   navigate(`/${fromPage}`);
        // } else if (fromPage == "JoinUs") {
        //   navigate(`/${fromPage}`, { state: { tab: "#three" } });
        // }else{
        //   navigate(`/${fromPage}`, { state: { testId: testId } });
        // }

      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleResendClick2 = async () => {
    try {
      const response = await fetch(`${baseurl}/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ candidate: contact }), // Resend OTP to the same contact
      });

      const data = await response.json();
      if (data.success) {
        alert("OTP resent successfully");
      } else {
        alert(data.message);

        // If already member → redirect to login
        if (data.message === "You are already a member") {
          setTimeout(() => {
            navigate("/memberlogin");   // redirect here
          }, 500);
        } else {
          // fallback redirect
          setTimeout(() => {
            navigate("/Register");
          }, 500);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div
      className={`container newlogin ${popupHidden ? "popup-hidden" : ""}`}
      id="container"
    >
      <div className="form-container sign-up">
        <form onSubmit={handleSubmitClick2} className="newform" >
          <h1>Verification Code</h1>
          <span>
            Please enter the verification code sent to your email.
          </span>
          <div>
            <div
              id="otp"
              className="inputs d-flex flex-row justify-content-center mt-2"
            >
              {otp.map((digit, index) => (
                <input
                  key={index}
                  className="otp-input m-2 text-center form-control rounded"
                  type="text"
                  maxLength={1}
                  value={digit}
                  autoFocus={index === 0}
                  ref={(ref) => (inputsRefs.current[index] = ref)}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onPaste={handlePaste}  // important
                  onKeyDown={(e) => handleKeyDown(index, e)}
                />
              ))}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              marginTop: "20px",
            }}
          >
            <button
              type="button"
              onClick={handleResendClick2}
              disabled={resendDisabled}
              style={{
                backgroundColor: resendDisabled ? "#eee" : "rgb(6 2 79)",
                color: "#fff",
              }}
            >
              Resend-OTP
            </button>
            <button type="submit">
              Submit
            </button>
          </div>
        </form>
      </div>

      <div className="form-container sign-in">
        <form className="newform" onSubmit={handleSubmit}>
          <h1>Candidate Sign In</h1>
          <span>Hello, Welcome Back!</span>
          <div className="input-wrapper">
            <input
              className="newinput"
              type="text"
              placeholder="Enter your email:"
              value={contact}
              onChange={(event) => setContact(event.target.value)}
            />
          </div>

          <button type="submit" id="register">
            Request OTP
          </button>

          <br />
          <h1>New here?</h1>
          <span>Please Register First...</span>
            <button
              className="mt-3 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 transition"
              onClick={() => navigate("/register", { state: { tab: "#three", testId: testId, page: fromPage } })}
            >
              Register
            </button>   
        </form>
   

      </div>

      <div className="toggle-container" style={{zIndex:'auto'}}> 
        <div className="toggle">
          <div className="toggle-panel toggle-left">
            <h1></h1>
            <p></p>
            <button className="hidden" id="login">
              Retry
            </button>
          </div>
          <div className="toggle-panel toggle-right">
            <h1 className="text-white"></h1>
            <p className="text-gray-200"></p>
            
          </div>

        </div>
      </div>
    </div>
  );
};

export default Candidatelogin;
